import { render, staticRenderFns } from "./IconPaysystemUnionPay.vue?vue&type=template&id=1e4f83cb&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports